import { QueryClient } from "@tanstack/react-query";

export default QueryClient;
